import React from 'react';
import { connect } from 'react-redux';

import DefaultHeader from './defaultHeaderComponent.js';
import ConclusionHeader from './conclusionHeaderComponent.js';

const HeaderView = ({ activeStep, stepList }) => {

    if (activeStep === stepList.length - 1) {
        return (
            <ConclusionHeader />
        );
    }

    return (
        <DefaultHeader />
    );
};

const mapStateToProps = state => ({
    activeStep: state.navigation.active,
    stepList: state.navigation.items,
});

const Header = connect(
    mapStateToProps,
    null
)(HeaderView);

export default Header;
